import { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/RootUserStyles/SystemAdministrators/NewSystemAdministrator.css";
import { SystemAdministratorContext } from "./SystemAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";
import { AppContext } from "../../../AppProvider";
import countries from "../../../../functions/getCountries";
const NewSystemAdministrator = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        showCreateNewSystemAdministratorWindow,setShowCreateNewSystemAdministratorWindow,
        setReloadSystemAdministrators
    } = useContext(SystemAdministratorContext);

    const [countryFilterString,setCountryFilterString] = useState('');
    const [showCountriesBrowser,setShowCountriesBrowser] = useState(false);

    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [emailAddress,setEmailAddress] = useState('');
    const [password,setPassword] = useState('');
    const [selectedCountry,setSelectedCountry] = useState();
    const [city,setCity] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [postalCode,setPostalCode] = useState('');
    const [address,setAddress] = useState('');
    const [address2,setAddress2] = useState('');
    const [createSystemAdministratorStatus,setCreateSystemAdministratorStatus] = useState('');
    const createSystemAdministrator = async() =>{
        setCreateSystemAdministratorStatus('creating');
        try{
            const newSystemAdministratorPayload = {
                firstName:firstName,
                lastName:lastName,
                emailAddress:emailAddress,
                password:password,
                country:selectedCountry,
                city:city,
                phoneNumber:phoneNumber,
                postalCode:postalCode,
                address:address,
                address2:address2
            };
            const url = `${usersMicroserviceUrl}/root/system-admins`;
            const response = await fetch(url,{
                method:'POST',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                },
                body:JSON.stringify(newSystemAdministratorPayload)
            });
            if(response.ok){
                setCreateSystemAdministratorStatus('created');
                setReloadSystemAdministrators(true);
                return;
            }
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when creating system administrator',error);
        }
        setCreateSystemAdministratorStatus('create-error');
    };
    const clearNewSystemAdministratorEntries= () =>{
        setCountryFilterString('');
        setShowCountriesBrowser('');
        setFirstName('');
        setLastName('');
        setEmailAddress('');
        setPassword('');
        setSelectedCountry('');
        setCity('');
        setPhoneNumber('');
        setPostalCode('');
        setAddress('');
        setAddress2('');
        setCreateSystemAdministratorStatus('');
    };
    const disposeWindow = () =>{
        clearNewSystemAdministratorEntries();
        setShowCreateNewSystemAdministratorWindow(false);
    };
    const validFormToolTipText = () =>{
        if(firstName === '') return 'Enter the first name to proceed';
        if(lastName === '') return 'Enter the last name to proceed';
        if(emailAddress === '') return 'Enter a valid email address to proceed';
        if(password === '') return 'Enter a valid password to proceed';
        if(selectedCountry === '' || selectedCountry === null) return "Select the user's country to proceed";
        if(city === '') return "Enter city name to proceed";
        return '';
    };
    useEffect(() =>{
        if(createSystemAdministratorStatus === 'created') setReloadSystemAdministrators(true);
    },[createSystemAdministratorStatus]);
    useEffect(() => {
        if(showCreateNewSystemAdministratorWindow) document.title = 'Blink IOT | New system administrator';
        else document.title = 'Blink IOT | System administrators';
    },[showCreateNewSystemAdministratorWindow]);
    useEffect(() => {
        const handleEsc = (e) =>{
            if(e.key === "Escape" && (createSystemAdministratorStatus === 'created' || createSystemAdministratorStatus === 'create-error')) disposeWindow();
        };
        document.addEventListener("keydown",handleEsc);
        return () => {
            document.removeEventListener("keydown",handleEsc);
        };
    },[showCreateNewSystemAdministratorWindow,createSystemAdministratorStatus]);
    if(!showCreateNewSystemAdministratorWindow) return null;
    return(
        <div className="root-user-new-system-administrator-parent-container">
            {createSystemAdministratorStatus === ''?
                (
                    <div className="root-user-new-system-administrator-container">
                        <div className="root-user-new-system-administrator-header">
                            <h1>Add system administrator</h1>
                            <p onClick={() => disposeWindow()}>&#10006;</p>
                        </div>
                        <div className="root-user-new-system-administrator-body">
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>First Name<span>*</span></p>
                                <input
                                    placeholder="Enter first name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Last Name<span>*</span></p>
                                <input
                                    placeholder="Enter last name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Email Address<span>*</span></p>
                                <input
                                    placeholder="Enter email address"
                                    value={emailAddress}
                                    onChange={(e) => setEmailAddress(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Password<span>*</span></p>
                                <input
                                    placeholder="Enter password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Country<span>*</span></p>
                                {selectedCountry?
                                    (
                                        <div className="root-user-new-system-administrator-selected-country-display">
                                            <p>{selectedCountry}</p>
                                            <p className="cancel-p" onClick={() => setSelectedCountry(null)}>&#10006;</p>
                                        </div>
                                    ):
                                    (
                                        <input
                                            placeholder="Select country"
                                            value={countryFilterString}
                                            onChange={(e) => setCountryFilterString(e.target.value)}
                                            onFocus={() => setShowCountriesBrowser(true)}
                                            onBlur={() => setTimeout(() => {setShowCountriesBrowser(false)},150)}
                                        />
                                    )
                                }
                                <div className={`root-user-new-system-administrator-countries-browser ${showCountriesBrowser? 'active':''}`}>
                                    {[...countries].filter(country => country.toLowerCase().includes(countryFilterString?.toLowerCase())).
                                        sort((a,b) => a.localeCompare(b)).map((country) =>(
                                        <div key={country} onClick={() =>{
                                            setSelectedCountry(country);
                                            setCountryFilterString('');
                                        }}>
                                            {country}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>City<span>*</span></p>
                                <input
                                    placeholder="Enter city"
                                    value={city}
                                    onChange={(e) => setCity(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Phone Number</p>
                                <input
                                    placeholder="Enter phone number"
                                    value={phoneNumber}
                                    onChange={(e) => setPhoneNumber(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Postal Code</p>
                                <input
                                    placeholder="Enter postal code"
                                    value={postalCode}
                                    onChange={(e) => setPostalCode(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Address</p>
                                <input
                                    placeholder="Enter address"
                                    value={address}
                                    onChange={(e) => setAddress(e.target.value)}
                                />
                            </div>
                            <div className="root-user-new-system-administrator-entry-container">
                                <p>Address 2</p>
                                <input
                                    placeholder="Enter address 2"
                                    value={address2}
                                    onChange={(e) => setAddress2(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="root-user-new-system-administrator-buttons-container">
                            <button className="cancel" onClick={() => disposeWindow()}>Cancel</button>
                            <button
                                className={`add ${validFormToolTipText() === ''? 'active':'inactive'}`}
                                title={validFormToolTipText()}
                                onClick={() =>{
                                    if(validFormToolTipText() !== '') return;
                                    createSystemAdministrator();
                                }}>Create</button>
                        </div>
                    </div>
                ):createSystemAdministratorStatus === 'creating'?
                (
                    <div className="root-user-new-system-administrator-creating-container">
                        <div></div>
                        <p>Creating system administrator. Please wait...</p>
                    </div>
                ):createSystemAdministratorStatus === 'created'?
                (
                    <div className="root-user-new-system-administrator-created-container">
                        <div className="root-user-new-system-administrator-created-details-container">
                            <p>System administrator created successfully</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="root-user-new-system-administrator-created-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):createSystemAdministratorStatus === 'create-error'?
                (
                    <div className="root-user-new-system-administrator-create-error-container">
                        <div className="root-user-new-system-administrator-create-error-details-container">
                            <p>Unexpected error occurred when creating system administrator</p>
                            <div>
                                <button onClick={() => disposeWindow()}>Okay</button>
                            </div>
                        </div>
                        <div className="root-user-new-system-administrator-create-error-escape-button-container"
                            onClick={() => disposeWindow()}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <></>
                )
            }
        </div>
    );
};
export default NewSystemAdministrator;